import { cva } from 'cva'

export const inputVariants = cva({
  base: [
    // 레이아웃
    ['flex', 'w-[248px]', 'h-[52px]', 'justify-between'],

    // 스타일링
    ['rounded-lg', 'border', 'border-input', 'bg-transparent', 'disabled:bg-gray-100'],

    // 패딩
    ['px-4', 'py-3.5'],

    // 텍스트
    ['text-xl', 'font-normal'],

    // 트랜지션
    'transition-colors',

    // 플레이스홀더
    ['placeholder:text-muted-foreground', 'placeholder:text-gray-400'],

    // 포커스
    ['focus-visible:outline-none', 'focus-visible:ring-[1.5px]', 'focus-visible:ring-gray-900'],

    // 비활성화 상태
    ['disabled:cursor-not-allowed', 'disabled:opacity-50'],
  ],

  variants: {
    variant: {
      default: [],
      error: ['bg-red-light', 'border-red-normal'],
    },
  },

  defaultVariants: {
    variant: 'default',
  },
})
